import { Component, OnInit, Inject, NgZone } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { AuthService } from '../../../services/auth/auth.service';
import { GuiToolsService } from '../../../services/shared/gui-tools.service';
import Swal from 'sweetalert2';
import { Translators } from 'src/app/services/shared/translators.service';
import { APP_CONFIG, IAppConfig } from '../../../app.config/app.config';
import { GuiMsjService } from 'src/app/services/shared/gui-msj.service';
import { MatDialog } from '@angular/material/dialog';
import { TermsConditions } from '../terms-conditions/terms-conditions.component';
import { Register } from 'src/app/interfaces/interface-frontend/register';
import { Catalogo } from 'src/app/interfaces/interface-bakend/shared/catalogo/catalogo.interface';
import { OpenPageService } from '../../../services/shared/open-page.service';
import { GecrosAfiliadosService } from 'src/app/services/entidades/gecros-afiliados.service';
import { SignoGecrosAfiliado } from 'src/app/interfaces/interface-bakend/entidades/signo-greco-afiliado.interface';
import { UsuarioService } from '../../../services/shared/usuario.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-auth-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {
  registerForm: FormGroup;
  loadingForm = false;
  loading: Subscription;
  showPasswordRegister: boolean = false;
  showPasswordConfirm: boolean = false;
  siteKey: string;
  idPasaporte: string;
  identificacion: string = '';
  viewSpinner: boolean = false;
  showTimeoutMessage: boolean = false;
  searchTimeout: any;
  flagDataGecros: boolean = false;
  dataGecros: SignoGecrosAfiliado = undefined;
  flagTitular: boolean = false;
  flagControlPrestaciones: boolean = false;
  flagFormaValido = false;
  signoSedeCodigo: string;
  signoPlan: string;
  flagMenorEdad: boolean = false;

  constructor(
    private authservice: AuthService,
    private guiToolsService: GuiToolsService,
    private translatorService: Translators,
    @Inject(APP_CONFIG) private iAppConfig: IAppConfig,
    public guiMsjService: GuiMsjService,
    public dialog: MatDialog,
    private openPageService: OpenPageService,
    private gecrosAfiliadosService: GecrosAfiliadosService,
    private zone: NgZone,
    private usuarioService: UsuarioService,
    private router: Router,
  ) {
    this.loading = this.guiToolsService.getLoading().subscribe((resp) => {
      this.loadingForm = resp;
    });
    this.createFormRegister();
  }

  ngOnInit(): void {
    this.siteKey = this.iAppConfig.recaptcha.siteKey;
    this.idPasaporte = this.iAppConfig.dniid;
    this.createListenersStateForm();
  }

  createFormRegister() {
    this.registerForm = new FormGroup({
      email: new FormControl('', [
        Validators.required,
        Validators.pattern('[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,3}$'),
      ]),
      confirmEmail: new FormControl('', [
        Validators.required,
        Validators.pattern('[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,3}$'),
      ]),
      password: new FormControl('', [
        Validators.required,
        Validators.minLength(6),
        Validators.maxLength(10),
      ]),
      confirmPassword: new FormControl('', [
        Validators.required,
        Validators.minLength(6),
        Validators.maxLength(10),
      ]),
      nombrePersona: new FormControl('', [
        Validators.required,
        Validators.minLength(3),
      ]),
      apellidoPersona: new FormControl('', [
        Validators.required,
        Validators.minLength(3),
      ]),
      identificacion: new FormControl('', [
        Validators.required,
        Validators.minLength(8),
        Validators.maxLength(15),
      ]),
      aceptaTerminos: new FormControl('', Validators.requiredTrue),
      proteccionDeDatos: new FormControl('', Validators.requiredTrue),
      clausula: new FormControl(false),
      recaptcha: new FormControl('', Validators.required),
    });
  }

  createListenersStateForm() {
    this.registerForm.get('email')?.valueChanges.subscribe(() => {
      this.registerForm.get('confirmEmail')?.reset();
    });

    this.registerForm.statusChanges.subscribe(async (status) => {
      if (
        status === 'VALID' &&
        this.flagDataGecros &&
        this.flagControlPrestaciones &&
        this.flagTitular
      ) {
        this.flagFormaValido = true;
      } else {
        this.flagFormaValido = false;
      }
    });
  }

  get emailNoValido() {
    const emailControl = this.registerForm.get('email');
    const emailValue = emailControl.value;
    const emailPattern = /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$/;
    return (
      !emailControl.valid &&
      emailControl.touched &&
      emailPattern.test(emailValue)
    );
  }

  get confirmEmailNoValido() {
    const email1 = this.registerForm.get('email').value;
    const email2 = this.registerForm.get('confirmEmail').value;
    return email1 === email2 ? false : true;
  }

  get passwordNoValido() {
    return (
      this.registerForm.get('password').invalid &&
      this.registerForm.get('password').touched
    );
  }

  get confirmPasswordNoValido() {
    const pass1 = this.registerForm.get('password').value;
    const pass2 = this.registerForm.get('confirmPassword').value;
    return pass1 === pass2 ? false : true;
  }

  get getNombreNoValido() {
    return (
      this.registerForm.get('nombrePersona').invalid &&
      this.registerForm.get('nombrePersona').touched
    );
  }

  get getApellidoNoValido() {
    return (
      this.registerForm.get('apellidoPersona').invalid &&
      this.registerForm.get('apellidoPersona').touched
    );
  }

  get getIdentificacionNoValida() {
    return (
      this.registerForm.get('identificacion').invalid &&
      this.registerForm.get('identificacion').touched
    );
  }

  async buscarAfiliadoGecros() {
    if (this.identificacion && this.identificacion.trim() !== '') {
      this.viewSpinner = true;
      this.showTimeoutMessage = false;

      clearTimeout(this.searchTimeout);

      this.searchTimeout = new Promise<void>((_, reject) => {
        setTimeout(() => {
          this.zone.run(() => {
            this.showTimeoutMessage = true;
          });
          reject(new Error('Timeout'));
        }, 3000);
      });

      try {
        const resp = await Promise.race([
          this.gecrosAfiliadosService.getAfiliadoByIdentificacion(
            this.identificacion,
          ),
          this.searchTimeout,
        ]);

        if (
          resp.data[0] !== undefined &&
          this.controlPrestaciones(resp.data[0]) &&
          this.usuarioService.esTitular(resp.data[0], true)
        ) {
          const afiliado = resp.data[0];

          if (afiliado.email) {
            afiliado.email = afiliado.email.trim().toLowerCase();
          }

          const nombresAfiliado: string[] =
            resp.data[0]?.nombreAfiliado.trim().split(/\s+/);
          const apellido = nombresAfiliado.pop().trim();
          const nombresSinApellido = nombresAfiliado.join(' ');

          this.flagTitular = true;
          this.flagDataGecros = true;
          this.dataGecros = resp.data[0];

          if (!this.validarEmail(afiliado.email)) {
            this.registerForm.controls['email'].setValue('');
            this.registerForm.controls['confirmEmail'].setValue('');
          } else {
            this.registerForm.controls['email'].setValue(
              afiliado.email?.trim() || null,
            );
            this.registerForm.controls['confirmEmail'].setValue(
              afiliado.email?.trim() || null,
            );
          }

          this.registerForm.controls['nombrePersona'].setValue(
            nombresSinApellido,
          );
          this.registerForm.controls['apellidoPersona'].setValue(
            apellido,
          );
          this.signoSedeCodigo =
            resp.data[0]?.numeroAfiliado.substring(0, 3);
          this.signoPlan = resp.data[0]?.plan;
        } else {
          this.flagTitular = false;
          this.flagDataGecros = false;
          this.dataGecros = undefined;
          this.registerForm.controls['email'].setValue(null);
          this.registerForm.controls['confirmEmail'].setValue(null);
          this.registerForm.controls['nombrePersona'].setValue(null);
          this.registerForm.controls['apellidoPersona'].setValue(
            null,
          );
          this.signoSedeCodigo = null;
          this.signoPlan = null;
        }
      } catch (error) {
        console.error('El DNI del asociado es vacío ', error);
        this.showTimeoutMessage = true;
      } finally {
        clearTimeout(this.searchTimeout);
        this.viewSpinner = false;
      }
    } else {
      this.viewSpinner = false;
    }
  }

  controlPrestaciones(afiliado) {
    if (afiliado !== undefined) {
      const convenio = afiliado.convenio.trim();
      switch (convenio) {
        case 'OSOETSYLRA':
        case 'OSOETSYLRA_SOM':
        case 'OSOETSYLRA_SYM':
          this.flagControlPrestaciones = true;
          return true;
        default:
          this.flagControlPrestaciones = false;
          Swal.fire({
            title: 'Convenio no válido',
            text: 'El convenio ingresado no es válido. Para recibir asistencia, comuníquese con nuestro equipo al 11 5815-2731. Disculpe las molestias ocasionadas.',
            icon: 'warning',
          });
          return false;
      }
    } else {
      return false;
    }
  }

  validarEmail(email: string): boolean {
    const re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@(([^<>()[\]\.,;:\s@"]+\.)+[^<>()[\]\.,;:\s@"]{2,})$/i;
    return re.test(email);
  }

  async registerUser() {
    if (this.registerForm.invalid) {
      return Object.values(this.registerForm.controls).forEach(
        (control) => {
          control.markAsTouched();
        },
      );
    }
    await this.guiMsjService.msjFormSubmit('Espere');
    Swal.showLoading();
    const success = await this.authservice.registerUser(await this.setDataForma());
    if (success) {
      this.router.navigate(['/login']);
    }
  }

  async setDataForma(): Promise<Register> {
    const data: Register = {
      nombrePersona: this.registerForm.value.nombrePersona,
      apellidoPersona: this.registerForm.value.apellidoPersona,
      tipoIdentificacion: this.idPasaporte,
      identificacion: this.registerForm.value.identificacion,
      email: this.registerForm.value.email,
      emailConfirm: this.registerForm.value.confirmEmail,
      password: this.registerForm.value.password,
      passwordConfirm: this.registerForm.value.confirmPassword,
      aceptaTerminos: this.registerForm.value.aceptaTerminos,
      proteccionDeDatos: this.registerForm.value.proteccionDeDatos,
      clausula: this.registerForm.value.clausula,
      fromWeb: true,
      fromApp: false,
      signoGecrosAfiliado: this.dataGecros,
      signoPlan: this.signoPlan != undefined ? this.signoPlan : null,
      codigoGecros:
        this.signoSedeCodigo != undefined ? this.signoSedeCodigo : null,
      notifica: true,
    };
    return data;
  }

  openBlank(type: string) {
    this.openPageService.openBlank(type);
  }
}
